import React from 'react';
import './PseudoPagePopup.less';
import {useMediaQuery} from "react-responsive";
import {largeScreenMediaQuery} from "new-constants/common.constants";
import {Popup} from "new-components/dialog-layout/popup/Popup";
import {DialogOverlay} from "new-components/dialog-layout/dialog-overlay/DialogOverlay";
import {PseudoPage} from "dialog-layout/pseudo-page/PseudoPage";
import {PopupHeader} from "compositions/popup-header/PopupHeader.tsx";

export const PseudoPagePopup = ({title, description, children, isInitial, onExternalLinkClick, onBackClick, onOverlayClick}) => {
	const isLargeScreen = useMediaQuery({query: largeScreenMediaQuery});

	if (isLargeScreen) {
		return <DialogOverlay onOverlayClick={onOverlayClick || onBackClick}>
			<Popup
				topStaticControl={(title || description || onBackClick) && (<PopupHeader
					title={title}
					description={description}
					onBackClick={onBackClick}
					onExternalLinkClick={onExternalLinkClick}
				/>)}
			>
				{children}
			</Popup>
		</DialogOverlay>
	} else {
		return <PseudoPage
			title={title}
			onBackClick={onBackClick}
			isNoScroll={isInitial}
			isNoPadding={isInitial}
		>
			{children}
		</PseudoPage>
	}
}
